<template>
  <div class="app-main">
    <el-row type="flex" class="app-main-header" align="middle">
      <el-col :span="6">
        <div class="router-title">
          <i class="el-icon-s-home"></i><span style="margin-left: 5px;">{{ $route.meta.title }}</span>
        </div>
      </el-col>
      <el-col :span="18" class="app-main-header-btns">
        <el-button size="small" type="primary" v-if="checkRole('cgy_role')"  @click="handleAdd" >新增 </el-button>
        <!-- <el-button size="small" type="primary" @click="handleBatchDel" >批量删除 </el-button> -->

        <!-- <el-dropdown style="margin-left:10px;">
          <el-button size="small" plain>更多操作<i class="el-icon-arrow-down el-icon--right"></i></el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <el-upload class="upload-demo" :action="baseURL+'/app/commodityClassification/import'"
                         :show-file-list="false" accept=".xls,.xlsx,application/msword"
                         :on-success="handleAvatarExcel" :before-upload="beforeExcel"
                         :headers="{'Authentication':token()}">
                <el-button size="mini" type="text"
                           v-hasPermi="['basic:commodityClassification:import']"
                           title="请按导出数据格式导入数据">导入Excel
                </el-button>
              </el-upload>
            </el-dropdown-item>
            <el-dropdown-item>
              <el-button size="mini" type="text" @click="handleExport"
                         v-hasPermi="['basic:commodityClassification:export']">导出Excel
              </el-button>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown> -->
      </el-col>
    </el-row>

    <el-row class="mg-b5">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <el-form :inline="true" class="demo-form-inline">
            <el-form-item class="my-form-item">
              <el-date-picker size="mini" :unlink-panels="true" type="daterange" range-separator="-"
                              v-model="quertInfo.searchTime" start-placeholder="开始日期"
                              value-format="yyyy-MM-dd"
                              style="width: 200px"
                              end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <!-- <el-form-item class="my-form-item">
              <el-select size="mini" clearable v-model="quertInfo.objMap.status"
                         style="width:100px"
                         placeholder="选择状态">
                <el-option label="启用" value="0"></el-option>
                <el-option label="禁用" value="1"></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item class="my-form-item">
              <el-input size="mini" placeholder="请输入查询条件" clearable v-model="quertInfo.objMap.search"
                        style="width: 160px"
                        prefix-icon="el-icon-search"></el-input>
            </el-form-item>
            <el-form-item class="my-form-item">
              <el-button size="mini" type="primary" @click="onSearch" >查询
              </el-button>
            </el-form-item>
          </el-form>
        </div>
        <!-- @selection-change="handleSelectionChange"  -->
        <el-table :data="tableData" border size="mini" :header-cell-style="headerCellStyle"
                  :height="PAGESIZE.h-170"

                  row-key="id"
					      :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
          >
          <!-- <el-table-column type="selection" width="40" align="left" :selectable="checkBoxDisable">
          </el-table-column> -->
          <!-- <el-table-column prop="code" label="分类编码"
                           :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <a @click="form=scope.row;drawer = true">
                {{ scope.row.code }}
              </a>
            </template>
          </el-table-column> -->
          <el-table-column prop="code" label="分类编码" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column prop="name" label="分类名"
                           :show-overflow-tooltip="true"></el-table-column>
          <!-- <el-table-column prop="parentId" label="上级分类"
                           :show-overflow-tooltip="true" width="120"></el-table-column>
          <el-table-column prop="status" label="状态"
                           :formatter="formatStatus"></el-table-column> -->
          <el-table-column prop="createTime" label="创建时间"
                           :show-overflow-tooltip="true" ></el-table-column>
          <el-table-column label="创建人"  prop="createUser">
          </el-table-column>
          <el-table-column label="操作"  align="left">
            <template slot-scope="scope">
              <el-button type="text" size="small" v-if="scope.row.id != 1" @click="handleEdit(scope.row)"
                         v-hasPermi="['basic:commodityClassification:edit']">修改
              </el-button>
              <el-button type="text" size="small" v-if="scope.row.id != 1" @click="handleDel(scope.row.id)"
                         v-hasPermi="['basic:commodityClassification:del']">删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- <el-row type="flex" justify="end" class="mg-t5">
          <pagination v-show="count>0" @on-pagination="onPagination" :page.sync="quertInfo.page"
                      :limit.sync="quertInfo.limit"
                      :total="count">
          </pagination>
        </el-row> -->
      </el-card>
    </el-row>
    <el-drawer title="我是标题" :visible.sync="drawer" custom-class="my-el-drawer" :with-header="false" size='60%'>
      <div class="my-el-drawer-body">
        <el-row type="flex" class="app-main-header mg-b15" align="middle">
          <el-col :span="6">
            <div class="router-title">
              <i class="el-icon-s-home"></i><span
                style="margin-left: 5px;">{{ $route.meta.title }}预览</span>
            </div>
          </el-col>
          <el-col :span="18" class="app-main-header-btns">
            <el-button type="primary" size="small" @click="handleEdit(form)"
                       v-hasPermi="['basic:commodityClassification:edit']">编辑
            </el-button>
          </el-col>
        </el-row>
        <el-collapse v-model="activeNames">
          <el-collapse-item name="1">
            <template slot="title">
              <div style="display: flex;align-items: center;">
                <el-divider direction="vertical"></el-divider>
                <span>物料分类</span>
              </div>
            </template>
            <el-card shadow="hover" style="border: none;">
              <el-descriptions :column="2" :border="false" :colon="false">
                <el-descriptions-item contentClassName="my-descriptions-conten"
                                      labelClassName="my-descriptions-label" label="分类编码">
                  {{ form.code }}
                </el-descriptions-item>
                <el-descriptions-item contentClassName="my-descriptions-conten"
                                      labelClassName="my-descriptions-label" label="分类名">
                  {{ form.name }}
                </el-descriptions-item>
                <el-descriptions-item contentClassName="my-descriptions-conten"
                                      labelClassName="my-descriptions-label" label="上级分类">
                  {{ form.parentId }}
                </el-descriptions-item>
                <el-descriptions-item contentClassName="my-descriptions-conten"
                                      labelClassName="my-descriptions-label" label="状态">
                  {{ form.status }}
                </el-descriptions-item>
                <el-descriptions-item contentClassName="my-descriptions-conten"
                                      labelClassName="my-descriptions-label" label="创建时间">
                  {{ form.createTime }}
                </el-descriptions-item>
                <el-descriptions-item contentClassName="my-descriptions-conten"
                                      labelClassName="my-descriptions-label" label="创建用户">
                  {{ form.createUser }}
                </el-descriptions-item>
              </el-descriptions>
            </el-card>
          </el-collapse-item>
        </el-collapse>
      </div>
    </el-drawer>
    <EditDialog ref="EditDialogRef" @callback="EditDialogCallback"/>
  </div>
</template>

<script>
import EditDialog from './EditDialog'
import {
  commodityClassificationList,
  delBasicClassify,
  batchDelBasicClassify,
  exportBasicClassify,
} from '@/api/basic/commodityClassification.js'

import { supplierClassificationList,delSupplierClassification,queryByParentId } from '@/api/gysmng/index.js'

export default {
  name: "BasicClassify",
  computed: {
			PAGESIZE:function(){
				return this.$store.getters['app/sizeInfo'];
			},
  },
  components:{
    EditDialog
  },
  data() {
    return {
      checkBoxDisable(row){
        if(row.id == 1){
          return false
        }
        return true
      },
      tableData: [],
      ids: [],
      form: {},
      activeNames: ['1'],
      loadingInstance: undefined,
      drawer: false,
      count: 0,
      quertInfo: {
        page: 1, //当前页码
        limit: 20, //当前每页显示的数量
        searchTime: [],
        objMap: {search: ''}
      },
    }
        ;
  },
  created() {
    this.getList();
  },
  methods: {
    onPagination: function (val) {
      this.quertInfo.page = val.page;
      this.quertInfo.limit = val.limit;
      this.getList();
    },
    async getList() {
      let _this = this;
      // const {
      //   data: res
      // } = await supplierClassificationList(_this.quertInfo)
      // if (res.code == 0) {
      //   _this.tableData = res.data;
      //   _this.count = res.count;
      // }

      const {
        data: res
      } = await queryByParentId({})
      if (res.code == 0) {
        _this.tableData = res.data[0].children;
        // _this.count = res.count;
      }


    },
    onSearch: function () {
      //重置页码（会出现查询搜索字段在当前页码之前，会查询不到）
      this.quertInfo.page = 1;
      this.getList();
    },
    handleAdd: function () {
      this.$refs.EditDialogRef.reset();
      this.$refs.EditDialogRef.getTreeselect();
      this.$refs.EditDialogRef.title = "新增";
      this.$refs.EditDialogRef.openDialog = true;
    },
    handleEdit: function (row) {
      this.$refs.EditDialogRef.reset();
      this.$refs.EditDialogRef.getTreeselect();
      this.$refs.EditDialogRef.title = "修改";
      this.$refs.EditDialogRef.form = JSON.parse(JSON.stringify(row)); //直接赋值 表格数据 也会改变 要深拷贝复制
      this.$refs.EditDialogRef.openDialog = true;
    },
    EditDialogCallback(obj){
      if(obj.type == 'getlist'){
        this.getList();
      }
    },
    handleSelectionChange(val) {
      this.ids = [];
      for (let item of val) {
        this.ids.push(item.id);
      }
    },
    handleBatchDel: function () {
      //批量删除
      let _this = this;
      if (_this.ids.length <= 0) {
        _this.$fail("请勾选要删除的行数据");
        return false;
      }
      _this.confirm({
        text: '确认删除吗',
        tip: '警告',
        type: '',
        fn: function (param) {
          batchDelBasicClassify(param).then(response => {
            if (response.data.code === 0) {
              _this.$success(response.data.msg);
              _this.getList();
            } else {
              _this.$fail(response.data.msg);
            }
          });
        },
        data: {
          ids: _this.ids
        } //参数对象 主要回调函数用
      });
    },


    handleDel: function (id) {
      let _this = this;
      _this.confirm({
        text: '确认删除吗',
        tip: '警告',
        type: '',
        fn: function (param) {
          delSupplierClassification(param).then(response => {
            if (response.data.code === 0) {
              _this.$success(response.data.msg);
              _this.getList();
            } else {
              _this.$fail(response.data.msg);
            }
          });
        },
        data: {
          id: id
        } //参数对象 主要回调函数用
      });
    },
    handleExport: function () {
      let _this = this;
      _this.confirm({
        text: '导出当前页，还是全部导出',
        but1: '全部导出',
        but2: '当前页',
        type: '',
        fn: function () {
          let param = JSON.parse(JSON.stringify(_this.quertInfo));
          param.page = 0;
          exportBasicClassify(param).then(response => {
            if (response.data.code === 0) {
              _this.download(response.data.data);
            } else {
              _this.$fail(response.data.msg);
            }
          });
        },
        cancel: function () {
          exportBasicClassify(_this.quertInfo).then(response => {
            if (response.data.code === 0) {
              _this.download(response.data.data);
            } else {
              _this.$fail(response.data.msg);
            }
          });
        },
      });
    },
    handleAvatarExcel(res, file) {
      if (res.code == 0) {
        this.getList();
      }
      this.loadingInstance.close();
      this.$success(res.msg);
    },
    beforeExcel(file) {
      // 判断文件后缀
      let type = file.name.substring(file.name.lastIndexOf('.') + 1);
      if (!(type == "xls" || type == "xlsx")) {
        this.$fail('请导入Excel文件');
        return false;
      }

      const isLt2M = file.size / 1024 / 1024 <= 1;
      if (!isLt2M) {
        this.$fail('导入Excel不能超过 1MB!');
        return false;
      }
      this.loadingInstance = this.Loading({
        text: '导入中请等待...'
      });
    },
    formatStatus: function (row) {
      return row.status == 0 ? '启用' : '禁用';
    },

  },
};
</script>
<style scoped="scoped">
</style>
